import { useEffect, useState } from 'react';

import { UsersListOption } from '../../../interfaces/note';
import { notesService } from '../../../services/notesService';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { sortArrAlphabetically } from '../../../../shared/utils/sortingAndGroupingUtil/sortArrAlphabetically/sortArrAlphabetically';

type UseUsersListProps = {
  userOption?: UsersListOption;
};

type UseUsersListReturn = {
  usersList: UsersListOption[];
};

// To use this hook, component should be MobX observer
export const useUsersList = ({ userOption }: UseUsersListProps): UseUsersListReturn => {
  const [usersList, setUsersList] = useState<UsersListOption[]>([]);

  const { isCoach, isEntity } = loggedInUserDataStore;

  const fetchUsersList = async () => {
    const { names } = await notesService.getUsersList();

    const sortedNames = sortArrAlphabetically(names, 'name');

    setUsersList(sortedNames);
  };

  const processUsersList = () => {
    // don't get for super because it will be too many users (check LMP-4891)
    if (isCoach || isEntity) {
      fetchUsersList();
    } else if (userOption) {
      setUsersList([userOption]);
    }
  };

  useEffect(() => {
    processUsersList();
  }, []);

  return { usersList };
};
